import axios from 'axios';

export const createAxios = (accessToken = undefined, language = undefined) => {
  let headers = {};
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }
  if (language) {
    headers['Accept-Language'] = language;
  }
  let config = {
    baseURL: `${import.meta.env.VITE_API_BASEURL ?? ''}/report`,
    timeout: 120000,
    headers,
  };
  return axios.create(config);
};
